/**
 * Inline legal document content — sanitized HTML per document type, scoped
 * to the requesting user's brand (ADR-088, spec 2026-07-06-per-brand-legal-content
 * AC C).
 *
 * Source of truth: `@hotelb2b/legal-content`'s registry, `getLegalContent(brandSlug)
 * .getSanitizedHtml(docType)` (build-time-generated, allowlisted-tag HTML,
 * safe to call at render time: sync, no `fs`, backed by a precomputed
 * `SANITIZED_LEGAL_HTML` constant — NEVER the live `node:fs`-reading function
 * of the same name in the package's Node-only `@hotelb2b/legal-content/server`
 * subpath). See spec docs/specifications/2026-07-03-legal-consent-soft-modal/spec.md,
 * "Inline HTML MUSI być sanityzowany" (anti-H1).
 *
 * `getSanitizedHtml` throws for an unknown/missing `brandSlug` (fail-closed,
 * ADR-088 C1) — a HotelB2B user must never fall back to KiedyNabory's content
 * (it carries the KN-only "Baza Danych o Naborach" anti-scraping clauses).
 * Every caller passes `brandSlug` from `PendingDoc.brandSlug`, which the
 * backend always resolves through the same registry — so this should never
 * throw in practice; if it does, that's a real leak risk worth surfacing
 * loudly rather than swallowing.
 */
import { getLegalContent, type LegalDocumentType } from "@hotelb2b/legal-content";

export function getSanitizedDocumentHtml(
  documentType: LegalDocumentType,
  brandSlug: string,
): string {
  return getLegalContent(brandSlug).getSanitizedHtml(documentType);
}
